"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const LanguageSwitcher_vue_1 = __importDefault(require("@/client/components/LanguageSwitcher.vue"));
const PreferencesIcon_vue_1 = __importDefault(require("@/client/components/PreferencesIcon.vue"));
const raw_settings = __importStar(require("@/genfiles/settings.json"));
const constants = __importStar(require("@/common/constants"));
exports.default = (0, vue_1.defineComponent)({
    name: 'start-screen',
    components: {
        LanguageSwitcher: LanguageSwitcher_vue_1.default,
        PreferencesIcon: PreferencesIcon_vue_1.default,
    },
    computed: {
        raw_settings() {
            return raw_settings;
        },
        DISCORD_INVITE() {
            return constants.DISCORD_INVITE;
        },
    },
});
